export default __webpack_public_path__ + "static/media/External.8148b5aa.svg";